import * as schemas from '@wix/auto_sdk_data-extension-schema_schemas';

export { schemas };
